import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "./login.css";

const Login = () => {
  const navigate = useNavigate();
  const [asuId, setAsuId] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    const isValid = asuId.trim() === "admin" && password.trim() === "admin";
    if (isValid) {
      setShowError(false);
      navigate("/admin");
    } else {
      setShowError(true);
    }
  };

  return (
    <div className="login-page">
      <Header title="Login" buttons={[{ to: "/", label: "Back" }]} />

      <main className="login-main">
        <div className="login-box">
          <img src="/assets/asu.png" alt="ASU Logo" className="login-logo" />
          <h2 className="login-title">ASU Login</h2>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className={`login-error${showError ? " visible" : ""}`}>
              ⚠️ Invalid ASU ID or Password
            </div>

            <div className="field">
              <label htmlFor="asuID">ASU ID</label>
              <input
                id="asuID"
                type="text"
                value={asuId}
                onChange={(event) => setAsuId(event.target.value)}
                placeholder="Enter your ASU ID"
                autoComplete="username"
              />
            </div>

            <div className="field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
              />
            </div>

            <button className="login-button" type="submit">
              Login
            </button>
          </form>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Login;
